import { ChangeDetectorRef, Component } from '@angular/core';
import { FieldType } from '@ngx-formly/core';
import { ContactCardListWidgetComponent } from '../contact-card-list-widget/contact-card-list-widget.component';

@Component({
  selector: 'app-formly-contact-card-list-widget',
  templateUrl: './formly-contact-card-list-widget.component.html',
  standalone: true,
  imports: [
    ContactCardListWidgetComponent
  ]
})
export class FormlyContactCardListWidgetComponent extends FieldType {


  constructor(private cd: ChangeDetectorRef) {
    super();
  }

}
